module.exports = __webpack_public_path__ + "media/images/A/Oval-101c11a153ce4b86eb7657c375641619.svg";